/* * 个人页面 * 作者：崔镇 */
<template>
    <div class="page-me-wrapper">
        <div class="scroll-view-scroll">
            <div class="cls-person">
                <!-- <div class="btn-personal" @click="gotoPersonal">个人主页</div> -->
                <div class="cls-head">
                    <img
                        alt="头像"
                        class="cls-logo"
                        :src="userImg || 'images/me.png'"
                        lazy="loaded"
                    />
                    <div class="cls-des">
                        <div class="cls-name">{{ userName }}</div>
                        <!-- <button type="button" @click="shareclick">分享</button> -->
                        <div class="cls-sign">Hi，欢迎来到优享免息~</div>
                    </div>
                </div>
                <div class="cls-icons">
                    <NativeOpenWeb
                        class="cls-item"
                        :url="discountLink"
                        :clstag="'jr|keycount|8530052_my_icon|coupons'"
                        :eventId="'MInterestFree_MyIconCoupon'"
                        :eventParam="'1'"
                    >
                        <span><img
                                src="images/paper.png"
                                alt="优惠券"
                                class="cls-icon-img"
                            /></span>

                        <span class="cls-icon-title">优惠券</span>
                    </NativeOpenWeb>
                    <!-- <div class="cls-item">
                        <router-link
                            to="/favorite"
                            class="J_Ping"
                            :clstag="'jr|keycount|8530052_my_icon|collect'"
                            report-eventid="MInterestFree_MyIconCollection"
                            report-eventparam="1"
                        >
                            <span><img
                                    src="images/folder.png"
                                    alt="收藏夹"
                                    class="cls-icon-img"
                                ></span>
                            <span class="cls-icon-title">收藏夹</span>
                        </router-link>
                    </div> -->
                    <KPL
                        refs="kplIns"
                        class="cls-item"
                        :url="link"
                        :clstag="'jr|keycount|8530052_index_bottom|cart'"
                    >
                        <span><img
                                src="images/shopping2.png"
                                alt="购物车"
                                class="cls-icon-img"
                            /></span>

                        <span class="cls-icon-title">购物车</span>
                    </KPL>
                    <KPL
                        class="cls-item"
                        :url="orderLink"
                        :clstag="'jr|keycount|8530052_my_icon|order'"
                        :eventId="'MInterestFree_MyIconOrder'"
                        :eventParam="'1'"
                    >
                        <span><img
                                src="images/order.png"
                                alt="订单"
                                class="cls-icon-img"
                            /></span>

                        <span class="cls-icon-title">订单</span>
                        <!-- <span class="cls-notice"></span> -->
                    </KPL>
                    <!-- <KPL
                        v-if="hasCard"
                        refs="kplIns"
                        class="cls-item"
                        :url="link"
                        :clstag="'jr|keycount|yxsc_navigation|shopping'"
                    >
                        <span><img
                                src="images/shopping2.png"
                                alt="购物车"
                                class="cls-icon-img"
                            ></span>
                        <span class="cls-icon-title">购物车</span>
                    </KPL> -->
                    <NativeOpenWeb
                        class="cls-item"
                        :url="btLink"
                        clstag="'jr|keycount|8530052_my_icon|huanbaitiao'"
                        :eventId="'MInterestFree_MyIconBT'"
                        :eventParam="'1'"
                    >
                        <span><img
                                src="images/huan.png"
                                alt="还白条"
                                class="cls-icon-img"
                            /></span>

                        <span class="cls-icon-title">还白条</span>
                    </NativeOpenWeb>
                </div>
            </div>
            <!-- 个人主页 -->
            <div
                class="ui-personal"
                @click="toPersonal"
            >
                <p class="ui-arr">个人主页</p>
            </div>
            <div class="cls-back">
                <div class="cls-content">
                    <!-- 量身推荐标题 -->
                    <div class="cls-head-line ">
                        <!-- <Headlines :Text="en_title" :showTitle="cn_title" style="padding:0"></Headlines> -->
                        <img
                            class="cls-img"
                            src="//m.360buyimg.com/jrqb/jfs/t27532/107/453175347/9344/40de0ca/5badf3b8N55089b04.png"
                        />
                    </div>
                    <BusCardList
                        ref="busCardList"
                        :data="cardList"
                        :hasMoreData="hasMoreData"
                        :eventId="'MInterestFree_MyPro'"
                        @onMoreElementInView="onMoreElementInView"
                        :clstagName="clstagName"
                        :channel="'recomend'"
                    />
                </div>
            </div>
        </div>

        <NavigationJd
            v-if="hasJdNav"
            ref="navjd"
            :isShow="true"
        />
        <Navigation
            v-if="hasNav"
            ref="nav"
        />
    </div>
</template>

<script>
// @ is an alias to /src
import ScrollView from '@/components/ScrollView.vue';
import BusCardList from '@/buscomponents/BusCardList.vue';
import Navigation from '@/buscomponents/Navigation.vue';
import NavigationJd from '@/buscomponents/NavigationJd.vue';
import NativeOpenWeb from '@/buscomponents/NativeOpenWeb.vue';
import request from '@/util/request';
import { shareOpen, shareInit, HideShare } from '@/util/share';
import KPL from '@/buscomponents/KPL.vue';
import { setJDJRNativeHeaderColor } from '@/util/jdjrNative';
import { genLinkBySSR, isJdNavFun, hasNavFun } from '@/util/common';
import Headlines from '@/buscomponents/Headlines.vue';
import { messages } from '@/config';

export default {
    name: 'me',
    components: {
        ScrollView,
        BusCardList,
        KPL,
        Headlines,
        Navigation,
        NativeOpenWeb,
        NavigationJd
    },
    data() {
        return {
            link: 'https://p.m.jd.com/cart/cart.action',
            discountLink: 'http://m.jr.jd.com/mjractivity/rn/coupon-rn/index.html?RN=coupon-rn&tab=BAITIAO',
            // orderLink: 'https://wqs.jd.com/order/orderlist_merge.shtml?tab=1&sceneval=2',
            orderLink: 'https://q.jd.com/m/react/index.html#@@%7B%22hash%22%3A%22orderList%22%7D@@',
            btLink: 'https://m.jr.jd.com/rn/BTMonthBill/index.html',
            ishow: false,
            pulldown: false,
            cardList: [],
            hasPlaceholder: false,
            lastId: '0',
            hasMoreData: true,
            userName: '',
            userImg: '',
            // 量身推荐标题
            en_title: 'RECOMMEND',
            cn_title: '量身推荐',
            hasCard: false,
            hasJdNav: false,
            hasNav: false,
            cash: {},
            clstagName: '8530052_1227_index_01'
        };
    },
    created() {
        try {
            HideShare({ title: '个人中心', moreItem: true, hideTools: false, textColor: 1 });
            const defaultOption = {
                shareURL: genLinkBySSR('activity'),
                shareImgSrc: 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png',
                shareTitle: messages.shareTitle,
                shareDesc: messages.shareDesc,
                shareChannels: ['0', '1', '3']
            };
            shareInit(defaultOption);
        } catch (error) {
            console.log(error);
        }

        const hasNav = hasNavFun(this.$route);
        const isJdNav = isJdNavFun(this.$route);
        if (isJdNav) {
            this.hasCard = true;
        }

        if (hasNav) {
            if (isJdNav) {
                this.hasJdNav = true;
            } else {
                this.hasNav = true;
            }
        }

        this.$loading.show();

        this.getList(1);
    },
    mounted() {},
    methods: {
        // gotoPersonal() {
        //     location.href = '//sq.jr.jd.com/usehome/useHomeIndex.action?showData=&showStyle=0';
        // },
        toPersonal() {
            location.href = '//sq.jr.jd.com/usehome/useHomeIndex.action?showData=&showStyle=0';
        },
        shareclick: function() {
            shareOpen({ shareURL: window.location.href, shareTitle: 'activityShareTitle', shareDesc: 'activityDesp' });
        },
        onMoreElementInView() {
            if (this.hasMoreData) {
                this.getList();
            }
        },
        getList() {
            if (this.cash[this.lastId]) {
                return;
            }
            this.cash[this.lastId] = true;
            request.personalRecommendation({
                // 参数
                data: {
                    lastId: this.lastId
                },
                // 成功
                success: ({ recommendGoodsList, nickname, avatar, lastId, isEnd }) => {
                    this.$loading.hide();
                    if (nickname) {
                        this.userName = nickname;
                    }
                    if (avatar) {
                        this.userImg = avatar;
                    }
                    if (recommendGoodsList && recommendGoodsList.length && !isEnd) {
                        this.cardList = this.cardList.concat(recommendGoodsList);
                        this.lastId = recommendGoodsList[recommendGoodsList.length - 1].skuId;
                        this.hasMoreData = true;
                    } else {
                        if (recommendGoodsList.length == 0 && !isEnd && lastId) {
                            this.lastId = lastId;
                            this.hasMoreData = true;
                            this.getList();
                        } else {
                            this.hasMoreData = false;
                        }
                    }
                    // this.$nextTick(() => {
                    //   this.$refs.scrollViewNav.refresh();
                    // });
                },
                // 接口失败
                afterError: () => {
                    this.cash[this.lastId] = false;
                    this.$loading.hide();
                }
            });
        }
    },
    destroyed() {
        this.$refs = null;
        this._self = null;
    }
};
</script>

<style lang="scss">
@import './../scss/mixin.scss';
$color: #fff;

.page-me-wrapper {
    width: 100%;
    height: 100%;
}

.logo {
    width: $rem200;
    height: $rem200;
}

.cls-back {
    position: relative;
    z-index: 1;
    width: 100%;

    &:before {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 30px;
        z-index: -1;
        background-color: #131311;
        content: '';
    }
}

.cls-person {
    height: $rem394;
    background-color: #000;
    background: url('//img12.360buyimg.com/jrpmobile/jfs/t1/3815/24/2800/313178/5b9799fcEc72f2b7e/897be98673331bf3.png') no-repeat;
    background-size: 100% 100%;
    .btn-personal {
        background: url('//m.360buyimg.com/jfe/jfs/t1/15411/9/14170/9474/5ca4acf3E99fcc5d5/7e9cf0c7ab62e9a3.png') no-repeat;
        width: $rem136;
        height: $rem64;
        background-size: 100% 100%;
        position: absolute;
        right: 0px;
        top: $rem96;
        font-family: PingFangSC-Semibold;
        color: #000;
        font-size: $rem24;
        line-height: $rem64;
        padding-left: $rem16;

        &::before {
            content: ' ';
            position: absolute;
            width: 100%;
            height: 100%;
            background: url('//m.360buyimg.com/jfe/jfs/t1/24262/23/14109/196/5ca4ae02Ea4d99aae/8af5df2c4d03c94c.png') no-repeat;
            background-size: $rem16 $rem16;
            background-position: $rem95 center;
        }
    }
    .cls-head {
        display: flex;
        padding: $rem58 0 $rem58 $rem50;
        color: #fff;
        font-family: 'PingFangSC-Regular';
        .cls-logo {
            width: $rem128;
            height: $rem128;
            border: $rem6 solid rgba(255, 255, 255, 0.2);
            border-radius: 50%;
        }
        .cls-des {
            display: flex;
            align-items: left;
            flex: 1;
            flex-direction: column;
            justify-content: center;
            padding-left: $rem40;
            .cls-name {
                height: $rem59;
                font-size: $rem42;
                line-height: $rem59;
            }
            .cls-sign {
                color: #999;
                font-size: $rem28;
                line-height: $rem40;
            }
        }
    }
    .cls-icons {
        display: flex;
        .cls-item {
            display: block;
            span {
                display: block;
            }
            position: relative;
            flex: 1;
            justify-content: center;
            text-align: center;
            .cls-icon-img {
                margin-bottom: $rem13;
                width: $rem60;
                height: $rem60;
            }
            .cls-icon-title {
                color: #ffffff;
                text-align: center;
                font-size: $rem24;
                font-family: 'PingFangSC-Regular';
                opacity: 0.6;
            }
            .cls-notice {
                position: absolute;
                bottom: $rem89;
                left: 60%;
                width: $rem16;
                height: $rem16;
                border-radius: 50%;
                background: #ff1736;
            }
        }
    }
}
.cls-content {
    height: 100%;
    border-radius: $rem30 $rem30 $rem2 $rem2;
    background: #ffffff;
    .cls-head-line {
        // padding-top: $rem48;
        // margin-bottom: $rem32;
    }
    .cls-img {
        width: 100%;
    }
}
.ui-personal {
    position: absolute;
    right: 0;
    top: $rem96;
    background-image: url('//m.360buyimg.com/jrqb/jfs/t1/36408/13/10151/6277/5d006e65E5fbda58d/1c58c5181a4802f0.png');
    background-size: $rem136 $rem64;
    height: $rem64;
    width: $rem136;
    line-height: $rem64;
    padding-right: $rem10;
}
.ui-arr {
    width: 100%;
    font-size: $rem24;
    color: #000000;
    padding-left: $rem14;
    padding-right: $rem14;
    background: url('//m.360buyimg.com/jrqb/jfs/t1/47868/17/2166/158/5d006e40Eaf492d3d/efc938c3515f894a.png') no-repeat;
    background-size: $rem16 $rem16;
    background-position: center right;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
}
</style>
